import React, { FC, ReactNode } from 'react'

import { Ocultar } from './ocultar-funcionalidade.style'

export const OcultarFuncionalidade: FC<ReactNode> = ({ children }) => (
  <Ocultar children={children} />
)
